<template>
    <div class="row px-2">

        <div v-for="(heads, keyTitle) in formattedGenerals" :key="keyTitle" class="col-12 col-sm-12 col-md-12 col-lg-12 note-section">
            <div class="d-flex align-items-start">
              <input
                class="form-check-input me-2 mt-1"
                type="checkbox"
                :id="`chk-${keyTitle}`"
                :value="keyTitle"
                v-model="selectedTitles"
              />
              <InvestigationCard :tableItems="heads" :title="keyTitle" :isBackground="false" class="flex-grow-1">
                <InvestigationResultTable
                    :tableItems="heads"
                    :antibioticsDrowdown="antibioticsDrowdown"
                    :hasGlobalMachineImage="hasAnyMachineImage"
                />
              </InvestigationCard>
            </div>
        </div>

    </div>
</template>

<script setup>
import {ref, watch, onMounted, computed} from 'vue';
import InvestigationCard from '@/components/molecule/company/hospital/investigation-general/InvestigationGeneralCard.vue';
import InvestigationResultTable from '@/components/molecule/company/hospital/investigation-general/InvestigationResultTable.vue';

const props = defineProps({
  formattedGenerals: Object,
  antibioticsDrowdown: Array,
});

const emit = defineEmits(['selection-change']);

const selectedTitles = ref([]);

onMounted(() => {
  selectedTitles.value = Object.keys(props.formattedGenerals);
});

const hasAnyMachineImage = computed(() => {
  return Object.values(props.formattedGenerals).some(items =>
          Array.isArray(items) && items.some(item =>
              item.investigation_report_type === 'machine_image' && item.result != null
          )
  );
});

watch(selectedTitles, newVal => {
  const selected = {};
  newVal.forEach(key => {
    selected[key] = props.formattedGenerals[key];
  });
  emit('selection-change', selected);
});
</script>
